/**
 * @generated SignedSource<<45231d373a981cf467ef26db0358586c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateReportTemplateInput = {
  clientMutationId?: string | null;
  reportTemplate: ReportTemplateInput;
};
export type ReportTemplateInput = {
  config?: any | null;
  createdAt?: any | null;
  deletedAt?: any | null;
  description?: string | null;
  name?: string | null;
  organizationId: any;
  rowId?: any | null;
  updatedAt?: any | null;
};
export type useReportTemplateCreateMutation$variables = {
  input: CreateReportTemplateInput;
};
export type useReportTemplateCreateMutation$data = {
  readonly createReportTemplate: {
    readonly reportTemplate: {
      readonly rowId: any;
      readonly id: string;
      readonly name: string | null;
      readonly config: any | null;
      readonly organization: {
        readonly id: string;
      } | null;
    } | null;
  } | null;
};
export type useReportTemplateCreateMutation = {
  variables: useReportTemplateCreateMutation$variables;
  response: useReportTemplateCreateMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateReportTemplatePayload",
    "kind": "LinkedField",
    "name": "createReportTemplate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ReportTemplate",
        "kind": "LinkedField",
        "name": "reportTemplate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rowId",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "config",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useReportTemplateCreateMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useReportTemplateCreateMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "008ff5267f65c32a9a6330eaa57c131d",
    "id": null,
    "metadata": {},
    "name": "useReportTemplateCreateMutation",
    "operationKind": "mutation",
    "text": "mutation useReportTemplateCreateMutation(\n  $input: CreateReportTemplateInput!\n) {\n  createReportTemplate(input: $input) {\n    reportTemplate {\n      rowId\n      id\n      name\n      config\n      organization {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "471a5cf47e0bd2d3dce6782ba554969a";

export default node;
